import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_337: DocMigration = {
  maxSchemaVersion: "0.0.337",
  description:
    "This was a temporal migration to differentiate old roofs during a validation process where the correct roofs where manually migrated.",
  apply(json: any) {
    // now it's empty

    return json;
  },
};

export default migration_0_0_337;
